import React, { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Logo1 from "../../assets/Logo1.png";
import Logo2 from "../../assets/Logo2.png";
import "./Navbar.scss";

import { useLocation, useHistory } from "react-router-dom";

const Navbar = () => {
	const [NavChange, setNavChange] = useState(false);
	const location = useLocation();

	const history = useHistory();
	const [SeeOpenRolesNav, setSeeOpenRolesNav] = useState(false);
	let myScrollFunc = useCallback(() => {
		let y = window.scrollY;
		if (y >= 490) {
			setSeeOpenRolesNav(true);
		} else {
			setSeeOpenRolesNav(false);
		}
	}, []);

	useEffect(() => {
		window.addEventListener("scroll", myScrollFunc);
		return () => {
			window.removeEventListener("scroll", myScrollFunc);
		};
	}, [myScrollFunc]);

	let locate = null;
	if (history.location.pathname === "/open-role") {
		locate = "Go Back"; // need confirmation on this
	}
	if (history.location.pathname === "/job-description") {
		locate = "Open Roles";
	}
	if (history.location.pathname === "/apply") {
		locate = "Go Back";
	}
	if (history.location.pathname === "/" && window.innerWidth >= 768) {
		if (SeeOpenRolesNav) {
			locate = "See Open Roles";
		}
	}

	const goBackHandler = (e) => {
		if (history.location.pathname === "/open-role") {
			history.push("/");
			return;
		}
		if (history.location.pathname === "/job-description") {
			history.push("/open-role");
		}
		if (history.location.pathname === "/apply") {
			history.push("/open-role");
		}
		if (
			history.location.pathname === "/" ||
			history.location.pathname === "/careers"
		) {
			history.push("/open-role");
		}
	};

	let NavbarProp = {
		borderColor: "#E5E5E5",
		style: {
			background: "#fff",
			boxShadow: "0px 4px 20px rgba(153, 153, 153, 0.2)",
			color: "black",
		},
		logo: Logo1,
	};
	if (location.pathname === "/") {
		NavbarProp = {
			borderColor: "#fff",
			style: {
				background: "transparent",
				color: "#FFF",
			},
			logo: Logo2,
		};
		const changeBgHandler = () => {
			if (window.scrollY >= 130) {
				setNavChange(true);
				return;
			} else {
				setNavChange(false);
			}
		};

		if (NavChange) {
			NavbarProp = {
				borderColor: "#E5E5E5",
				style: {
					background: "#fff",
					boxShadow: "0px 4px 20px rgba(153, 153, 153, 0.2)",
					color: "black",
				},
				logo: Logo1,
			};
		}

		window.addEventListener("scroll", changeBgHandler);
	}

	return (
		<header className='Header' style={NavbarProp.style}>
			<Link
				to='/'
				className='Header__brand'
				style={{ borderColor: NavbarProp.borderColor }}
			>
				<img src={NavbarProp.logo} alt='classplus-logo' width='122px' />
			</Link>
			<nav className='Header__main-nav'>
				<ul className='Header__links'>
					<li className='Header__link'>Opportunities</li>
					{locate && window.innerWidth >= 500 && (
						<li
							onClick={goBackHandler}
							style={{ color: "inherit" }}
							className='Header__link'
						>
							{locate}
						</li>
					)}
					{/* <li className='Header__link'>Teams</li>
					<li className='Header__link'>We Are Classplus</li> */}
				</ul>
			</nav>
		</header>
	);
};

export default Navbar;
